import React, { useState } from "react";
import Select from "react-select";
import UploadDocuments from "./UploadDocuments";

const BankDetails = ({
  validation,
  isCashSelected,
  setIsCashSelected,
  isUpdate = false,
}) => {
  const payModeOptions = [
    { value: "", label: "Select One" },
    { value: "cash", label: "Cash" },
    { value: "cheque", label: "Cheque" },
    { value: "bank_transfer", label: "Bank Transfer" },
  ];
  return (
    <div>
      <div className="card-title mt-2 ">Bank Details</div>
      <div className="mt-4">
        <div className="row">
          {/* Left Column */}
          <div className="col-md-5">
            {/* Salary Pay Mode */}
            <div className="mb-3 row">
              <label
                htmlFor="salary_pay_mode"
                className="col-md-4 col-form-label"
              >
                Salary Pay mode <span className="text-danger">*</span>
              </label>
              <div className="col-md-8">
                <Select
                  inputId="salary_pay_mode"
                  name="salary_pay_mode"
                  options={payModeOptions}
                  value={payModeOptions.find(
                    (option) =>
                      option.value === validation.values.salary_pay_mode
                  )}
                  onChange={(selectedOption) => {
                    const selectedValue = selectedOption?.value || "";

                    // Update Formik field
                    validation.setFieldValue("salary_pay_mode", selectedValue);

                    // Update isCashSelected state
                    setIsCashSelected(selectedValue === "cash" || selectedValue === "cheque");
                  }}
                  className={
                    validation.touched.salary_pay_mode &&
                    validation.errors.salary_pay_mode
                      ? "border-color"
                      : ""
                  }
                />
                {validation.touched.salary_pay_mode &&
                  validation.errors.salary_pay_mode && (
                    <div className="error-message">
                      {validation.errors.salary_pay_mode}
                    </div>
                  )}
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-md-7">
            {/* EPF and UAN */}
            <div className="row mb-3">
              <div className="col-md-2">
                <label htmlFor="epf_no" className="col-form-label">
                  EPF No.
                </label>
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  id="epf_no"
                  name="epf_no"
                  className="form-control"
                  value={validation.values.epf_no}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                />
              </div>
              <div className="col-md-2">
                <label htmlFor="uan_no" className="col-form-label">
                  UAN No.
                </label>
              </div>
              <div className="col-md-4">
                <input
                  type="text"
                  id="uan_no"
                  name="uan_no"
                  className="form-control"
                  value={validation.values.uan_no}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                />
              </div>
            </div>

            {/* Name in Bank */}
          </div>
        </div>
        {!isCashSelected && (
          <div className="row">
            {/* Left Side (3 fields) */}
            <div className="col-md-5">
              {/* Bank Name */}
              <div className="mb-3 row">
                <label htmlFor="bank_name" className="col-md-4 col-form-label">
                  Bank Name <span className="text-danger">*</span>
                </label>
                <div className="col-md-8">
                  <input
                    type="text"
                    id="bank_name"
                    name="bank_name"
                    className={`form-control ${
                      validation.touched.bank_name &&
                      validation.errors.bank_name
                        ? "is-invalid"
                        : ""
                    }`}
                    value={validation.values.bank_name}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                  />
                  {validation.touched.bank_name &&
                    validation.errors.bank_name && (
                      <div className="invalid-feedback">
                        {validation.errors.bank_name}
                      </div>
                    )}
                </div>
              </div>

              {/* Branch */}
              <div className="mb-3 row">
                <label htmlFor="branch" className="col-md-4 col-form-label">
                  Branch <span className="text-danger">*</span>
                </label>
                <div className="col-md-8">
                  <input
                    type="text"
                    id="branch"
                    name="branch"
                    className={`form-control ${
                      validation.touched.branch && validation.errors.branch
                        ? "is-invalid"
                        : ""
                    }`}
                    value={validation.values.branch}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                  />
                  {validation.touched.branch && validation.errors.branch && (
                    <div className="invalid-feedback">
                      {validation.errors.branch}
                    </div>
                  )}
                </div>
              </div>

              {/* IFSC Code */}
              <div className="mb-3 row">
                <label htmlFor="ifsc_code" className="col-md-4 col-form-label">
                  IFSC Code <span className="text-danger">*</span>
                </label>
                <div className="col-md-8">
                  <input
                    type="text"
                    id="ifsc_code"
                    name="ifsc_code"
                    className={`form-control ${
                      validation.touched.ifsc_code &&
                      validation.errors.ifsc_code
                        ? "is-invalid"
                        : ""
                    }`}
                    value={validation.values.ifsc_code}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                  />
                  {validation.touched.ifsc_code &&
                    validation.errors.ifsc_code && (
                      <div className="invalid-feedback">
                        {validation.errors.ifsc_code}
                      </div>
                    )}
                </div>
              </div>
            </div>

            {/* Right Side (3 fields) */}
            <div className="col-md-7">
              {/* Name in Bank */}
              <div className="mb-3 row">
                <label
                  htmlFor="name_in_bank"
                  className="col-md-4 col-form-label"
                >
                  Name in Bank <span className="text-danger">*</span>
                </label>
                <div className="col-md-8">
                  <input
                    type="text"
                    id="name_in_bank"
                    name="name_in_bank"
                    className={`form-control ${
                      validation.touched.name_in_bank &&
                      validation.errors.name_in_bank
                        ? "is-invalid"
                        : ""
                    }`}
                    value={validation.values.name_in_bank}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                  />
                  {validation.touched.name_in_bank &&
                    validation.errors.name_in_bank && (
                      <div className="invalid-feedback">
                        {validation.errors.name_in_bank}
                      </div>
                    )}
                </div>
              </div>

              {/* Account No */}
              <div className="mb-3 row">
                <label htmlFor="account_no" className="col-md-4 col-form-label">
                  Account No <span className="text-danger">*</span>
                </label>
                <div className="col-md-8">
                  <input
                    type="text"
                    id="account_no"
                    name="account_no"
                    className={`form-control ${
                      validation.touched.account_no &&
                      validation.errors.account_no
                        ? "is-invalid"
                        : ""
                    }`}
                    value={validation.values.account_no}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                  />
                  {validation.touched.account_no &&
                    validation.errors.account_no && (
                      <div className="invalid-feedback">
                        {validation.errors.account_no}
                      </div>
                    )}
                </div>
              </div>

              {/* Confirm Account No */}
              {!isUpdate && (
                <div className="mb-3 row">
                  <label
                    htmlFor="confirm_account_no"
                    className="col-md-4 col-form-label"
                  >
                    Confirm Account <span className="text-danger">*</span>
                  </label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      id="confirm_account_no"
                      name="confirm_account_no"
                      className={`form-control ${
                        validation.touched.confirm_account_no &&
                        validation.errors.confirm_account_no
                          ? "is-invalid"
                          : ""
                      }`}
                      value={validation.values.confirm_account_no}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                    />
                    {validation.touched.confirm_account_no &&
                      validation.errors.confirm_account_no && (
                        <div className="invalid-feedback">
                          {validation.errors.confirm_account_no}
                        </div>
                      )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <div className="card-title mt-2 ">Upload Document</div>
      {/* <UploadDocuments  documentsToSend={documentsToSend} setDocumentsToSend= {setDocumentsToSend}/> */}
    </div>
  );
};
export default BankDetails;
